
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Adventureresortnearchandrapur() {



  const cardData =
  {
    keyword: ' Adventure Resorts Near Chandrapur',
    heading:  'Woodland Escape: Adventure Resorts Near Chandrapur ',
    headingDescription: 'Woodland Escape Resort offers an exciting option among adventure resorts near Chandrapur, inviting thrill-seekers and nature-enthusiasts to experience a day of fun and activity in its lush, forest-fringed setting. Positioned within comfortable reach of Chandrapur, the resort features open lawns for team games, rustic trails for nature treks, and shaded outdoor areas perfect for camp-style gatherings and spontaneous explorations. Guests can unleash their adventurous side with light trekking, forest walks, picnic-style challenges, and evening bonfires amid the greenery, then relax in cozy cottages as night falls. With wholesome meals, family-friendly amenities, and warm hospitality, Woodland Escape Resort near Chandrapur combines the spirit of adventure with the comfort of a resort — making it a go-to destination for groups and families looking to add an active twist to their getaway.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Adventure Resorts Near Chandrapur",
      "description": "Discover thrilling adventure resorts near Chandrapur offering activities like trekking, zip-lining, rock climbing, and camping. Perfect for adventure enthusiasts and families looking for an adrenaline-filled getaway, these resorts provide comfortable accommodations amidst scenic surroundings."
    },
    {
      "name": "Chandrapur Adventure Park",
      "description": "Explore Chandrapur Adventure Park featuring obstacle courses, rope activities, and outdoor challenges. Ideal for families, groups, and solo travelers, the park provides safe and exciting experiences in a natural setting, combining fun with fitness and adventure."
    },
    {
      "name": "Chandrapur Outdoor Adventure Resort",
      "description": "Experience outdoor adventures at Chandrapur’s dedicated resorts offering activities such as kayaking, hiking, and nature trails. Enjoy a perfect blend of excitement and relaxation with amenities like picnic areas, guided tours, and scenic views."
    },
    {
      "name": "Chandrapur One Day Adventure Trip",
      "description": "Plan a one-day adventure trip in Chandrapur with activities like trekking, river rafting, and team-building games. Suitable for families, friends, and corporate groups, these trips provide a fun-filled day of excitement and exploration."
    },
    {
      "name": "Affordable Adventure Resort Chandrapur",
      "description": "Experience budget-friendly adventure resorts in Chandrapur offering thrilling activities and comfortable stays without stretching your wallet. Perfect for students, families, and travelers seeking adventure on a budget."
    },
    {
      "name": "Chandrapur Family Adventure Resort",
      "description": "Enjoy a family-oriented adventure stay with activities for all ages including nature walks, obstacle courses, and interactive games. These resorts focus on safety, fun, and bonding opportunities, making it ideal for a family getaway."
    },
    {
      "name": "Chandrapur Kids Adventure Resort",
      "description": "Take your children to a fun-filled kids adventure resort in Chandrapur with safe climbing structures, playgrounds, treasure hunts, and guided outdoor activities. Perfect for creating lasting memories with your little adventurers."
    },
    {
      "name": "Chandrapur Weekend Adventure Trip",
      "description": "Turn your weekend into an adventurous escape with Chandrapur’s weekend trips featuring trekking, river activities, and outdoor games. Rejuvenate your mind and body while enjoying nature’s thrills with friends or family."
    },
    {
      "name": "Chandrapur Hill Adventure Resort",
      "description": "Escape to hill adventure resorts near Chandrapur offering panoramic views, trekking paths, and adrenaline-filled outdoor activities. Ideal for nature lovers and adventure seekers wanting a refreshing highland retreat."
    },
    {
      "name": "Chandrapur River Adventure Spot",
      "description": "Enjoy water-based adventures at Chandrapur’s riverside resorts with activities like kayaking, rafting, and fishing. Perfect for families and groups seeking a fun-filled day near calm or exciting waters."
    },
    {
      "name": "Chandrapur Outdoor Activity Resort",
      "description": "Engage in multiple outdoor activities at Chandrapur resorts including camping, nature trails, obstacle courses, and sports. These resorts combine adventure, relaxation, and scenic beauty for a complete experience."
    },
    {
      "name": "Chandrapur Short Adventure Trip",
      "description": "Plan a short adventure trip around Chandrapur for a quick dose of excitement. Enjoy trekking, river activities, and team-building exercises within a single day or weekend, making it perfect for busy travelers."
    },
    {
      "name": "Chandrapur Adventure Booking",
      "description": "Easily book your adventure resort or day trip in Chandrapur online to secure your preferred date, activities, and accommodations. Enjoy a hassle-free booking experience for an exciting adventure getaway."
    },
    {
      "name": "Chandrapur Excursion Packages",
      "description": "Choose from curated adventure excursion packages in Chandrapur including transport, meals, and guided activities. Perfect for families, corporate groups, or friends looking for a fully organized adventure experience."
    },
    {
      "name": "Chandrapur Resort Adventure Activities",
      "description": "Experience a variety of adventure activities at Chandrapur resorts including zip-lining, trekking, kayaking, and outdoor sports. Designed for thrill-seekers and families alike, these resorts offer safe, fun, and memorable experiences in a natural setting."
    }
  ],
  "tableData": [
    ["- Adventure Resorts Near Chandrapur", "- Chandrapur Adventure Park"],
    ["- Chandrapur Outdoor Adventure Resort", "- Chandrapur One Day Adventure Trip"],
    ["- Affordable Adventure Resort Chandrapur", "- Chandrapur Family Adventure Resort"],
    ["- Chandrapur Kids Adventure Resort", "- Chandrapur Weekend Adventure Trip"],
    ["- Chandrapur Hill Adventure Resort", "- Chandrapur River Adventure Spot"],
    ["- Chandrapur Outdoor Activity Resort", "- Chandrapur Short Adventure Trip"],
    ["- Chandrapur Adventure Booking", "- Chandrapur Excursion Packages"],
    ["- Chandrapur Resort Adventure Activities", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Thrilling Adventure Resort Near Chandrapur",
    "WhyChoosedescription": "Woodland Escape Resort is the ultimate destination for adventure seekers near Chandrapur. Surrounded by nature, it offers a mix of excitement, outdoor fun, and relaxation — perfect for thrill lovers and nature enthusiasts alike."
  },
  {
    "WhyChooseheading": "Exciting Outdoor Activities",
    "WhyChoosedescription": "Enjoy a range of adventure activities such as cycling, trekking, nature walks, and light outdoor games. The resort provides safe yet thrilling experiences suitable for all ages."
  },
  {
    "WhyChooseheading": "Scenic and Natural Surroundings",
    "WhyChoosedescription": "Set amidst lush greenery and forested landscapes, the resort creates a perfect backdrop for outdoor adventures. It’s a place where you can explore nature while enjoying adrenaline-pumping fun."
  },
  {
    "WhyChooseheading": "Ideal for Adventure Groups and Families",
    "WhyChoosedescription": "Whether you’re visiting with friends, colleagues, or family, Woodland Escape Resort offers adventure-filled experiences that bring people together through fun challenges and outdoor bonding."
  },
  {
    "WhyChooseheading": "Relaxation After Adventure",
    "WhyChoosedescription": "After an active day, unwind by the pond, rest in shaded sit-outs, or enjoy peaceful moments surrounded by nature. The resort balances excitement with tranquility for the perfect getaway."
  },
  {
    "WhyChooseheading": "Delicious Food and Refreshments",
    "WhyChoosedescription": "Recharge with freshly prepared local dishes, snacks, and beverages. The resort’s food services ensure that your adventure trip is as satisfying for your taste buds as it is thrilling."
  },
  {
    "WhyChooseheading": "Convenient Location Near Chandrapur",
    "WhyChoosedescription": "Located just a short drive from Chandrapur, Woodland Escape Resort is easy to reach and perfect for a day of adventure and fun without long travel hours."
  }
]



















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as an adventure resort near Chandrapur?",
    answer: "Woodland Escape Resort is one of the most exciting adventure resorts near Chandrapur, offering a mix of nature, thrill, and relaxation. It’s a great destination for those who love outdoor activities and want to spend an adventurous day in the lap of nature."
  },
  {
    question: "How far is Woodland Escape Resort from Chandrapur city?",
    answer: "The resort is conveniently located within a comfortable driving distance from Chandrapur, making it perfect for a short adventurous trip or weekend getaway with friends and family."
  },
  {
    question: "What adventure activities are available at Woodland Escape Resort?",
    answer: "Guests can enjoy cycling, trekking, outdoor games, nature trails, and other fun-filled adventure activities. The resort offers a perfect balance of excitement and peace amidst greenery."
  },
  {
    question: "Is Woodland Escape Resort suitable for adventure lovers and families?",
    answer: "Yes! The resort caters to both adventure enthusiasts and families. While thrill-seekers enjoy outdoor activities, families can relax in the scenic, safe, and peaceful surroundings."
  },
  {
    question: "Does the resort provide food and refreshments for adventure guests?",
    answer: "Yes, Woodland Escape Resort offers freshly prepared meals, snacks, and beverages. Adventure packages can include lunch and refreshments, ensuring guests have an energetic and enjoyable day."
  },
  {
    question: "How can we book an adventure day at Woodland Escape Resort near Chandrapur?",
    answer: "You can easily book by calling or sending a WhatsApp message to our reservations team, or by visiting our official website. Advance booking is recommended for groups and weekend visits."
  }
];

const testimonials = [
  {
    name: "Mr. Akash & Friends, Chandrapur",
    text: "We had an adventurous and fun-filled day at Woodland Escape Resort! The activities were exciting, the food was tasty, and the natural surroundings made it even better. Perfect adventure resort near Chandrapur!"
  },
  {
    name: "Ms. Rina & Team, Chandrapur",
    text: "Woodland Escape Resort is an excellent spot for adventure lovers. We enjoyed cycling and outdoor games, followed by a relaxing time in nature. Highly recommended for a group adventure trip!"
  }
];






















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Adventure Resorts Near Chandrapur",
  "image": "https://woodlandescape.com/assets/images/adventure-resort-chandrapur.jpg",
  "description": "Discover thrilling adventure resorts near Chandrapur at Woodlandescape Resort. Enjoy outdoor activities, hill and riverside adventures, family-friendly excursions, and fun-packed one day trips.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "132"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2299",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/adventure-resorts-chandrapur"
  }
};




  return (
    <div>
<Helmet>
  <title>Adventure Resorts Near Chandrapur | Thrilling Outdoor Activities | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Experience thrilling adventure resorts near Chandrapur at Woodlandescape Resort. Enjoy outdoor activities, hill and riverside adventures, family-friendly excursions, and fun-packed one day trips." 
  />
  <meta 
    name="keywords" 
    content="Adventure Resorts Near Chandrapur, Chandrapur Adventure Park, Chandrapur Outdoor Adventure Resort, Chandrapur One Day Adventure Trip, Affordable Adventure Resort Chandrapur, Chandrapur Family Adventure Resort, Chandrapur Kids Adventure Resort, Chandrapur Weekend Adventure Trip, Chandrapur Hill Adventure Resort, Chandrapur River Adventure Spot, Chandrapur Outdoor Activity Resort, Chandrapur Short Adventure Trip, Chandrapur Adventure Booking, Chandrapur Excursion Packages, Chandrapur Resort Adventure Activities" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/26.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Adventureresortnearchandrapur;